define(function (require) {
    'use strict';

    var LE = require("app");

    var BaseRouterController = require("controllers/BaseRouterController");
    var LEConfig = require("assets/config/le-env-conf");

    var ModuleTabsController = require("user-management-controllers/ModuleTabsController");
    var SkillEditController = require("user-management-controllers/skills/SkillEditController");
    var ProfileEditController = require("user-management-controllers/profiles/ProfileEditController");
    var AgentGroupEditController = require("user-management-controllers/agent-groups/AgentGroupEditController");
    var AgentGroupMoveController = require("user-management-controllers/agent-groups/AgentGroupMoveController");
    var UserEditController = require("user-management-controllers/users/UserEditController");
    var UserWithProfilesEditController = require("user-management-controllers/users/UserWithProfilesEditController");
    var LobEditController = require("user-management-controllers/lobs/LobEditController");
    var NoData = require("ui.components/no-data/NoData");

    var UserManagementRouteController = {};
    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserManagementRouteController = BaseRouterController.extend({

            initialize: function(){
                this.dataManager = LEUserManagement.getDataManager();

                this.moduleTabsController = new ModuleTabsController();
                if (LE.sessionManager.hasProfilesFeature()) {
                    this.userEditController = new UserWithProfilesEditController();
                }
                else {
                    this.userEditController = new UserEditController();
                }
                this.skillEditController = new SkillEditController();
                this.profileEditController = new ProfileEditController();
                this.agentGroupEditController = new AgentGroupEditController();
                this.agentGroupMoveController = new AgentGroupMoveController();
                this.lobEditController = new LobEditController();
                this.currentController = null;
                this.navigation.defaultRoute = this.moduleTabsController.getFirstTabPath();
            },

            navigation: {
                routes: {
                    "users": {
                        callback: "showUserList",
                        name: "PeopleList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_USER_LIST]
                        }
                    },
                    "users/:userId": {
                        name: "EditPerson",
                        callback: "showUserEdit",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_USER_LIST]
                        }
                    },
                    "users/new": {
                        name: "EditPerson",
                        callback: "showAddUser",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_USERS, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_MANAGER]
                        }
                    },
                    "users/duplicate/:userId": {
                        name: "EditPerson",
                        callback: "showDuplicateUser",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_USERS, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_MANAGER]
                        }
                    },
                    "skills": {
                        callback: "showSkillList",
                        name: "SkillsTable",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_SKILL_LIST]
                        }
                    },
                    "skills/:skillId": {
                        name: "EditSkill",
                        callback: "showSkillEdit",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_SKILL_LIST]
                        }
                    },
                    "skills/new": {
                        name: "EditSkill",
                        callback: "showAddSkill",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_SKILLS]
                        }
                    },
                    "agentGroups": {
                        callback: "showAgentGroupsList",
                        name: "AgentGroupsList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_AGENT_GROUP_LIST]
                        }
                    },
                    "agentGroups/:agentGroupId": {
                        callback: "showAgentGroupEdit",
                        name: "EditAgentGroup",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_AGENT_GROUP_LIST]
                        }
                    },
                    "agentGroups/:agentGroupId/new": {
                        callback: "showAgentGroupAdd",
                        name: "AddGroupsList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.CREATE_AC_USERS_AGENT_GROUPS, LE.sessionManager.PRIVILEGES.MANAGE_AC_USERS_AGENT_GROUPS_UMBAM]
                        }
                    },
                    "agentGroups/:agentGroupId/move": {
                        callback: "showAgentGroupMove",
                        name: "AgentGroupsList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_GROUPS, LE.sessionManager.PRIVILEGES.MANAGE_AC_USERS_AGENT_GROUPS_UMBAM]
                        }
                    },
                    "profiles": {
                        callback: "showProfileList",
                        name: "ProfileList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_PROFILE_LIST]
                        }
                    },
                    "profiles/:profileId": {
                        name: "EditProfile",
                        callback: "showProfileEdit",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_PROFILE_LIST]
                        }
                    },
                    "profiles/new": {
                        name: "EditProfile",
                        callback: "showAddProfile",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_PROFILES, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_PROFILES, LE.sessionManager.PRIVILEGES.EDIT_AC_USERS_AGENT_MANAGER_PROFILES]
                        }
                    },
                    "lobs": {
                        callback: "showLobList",
                        name: "LobList",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_LOB_LIST]
                        }
                    },
                    "lobs/:lobId": {
                        name: "EditLob",
                        callback: "showLobEdit",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.VIEW_LE_LOB_LIST]
                        }
                    },
                    "lobs/new": {
                        name: "EditLob",
                        callback: "showAddLob",
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.EDIT_AC_LOB]
                        }
                    }
                },
                defaultRoute: ""
            },

            showUserList: function() {
                LEUserManagement.logger.debug("showUserList called" ,"UserManagementRouteController:showUserList");

                var deps = [
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true, isPersist: true}},
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: false, isPersist: true}},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: false, isPersist: true}},
                    {name: this.dataManager.getEntities().SITE_SETTINGS_USER_LIST, options: {isLazy: true}}
                ];
                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: false, isPersist: true}});
                    if (!LEUserManagement.hasAllUsersViewPrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}, isPersist: true}});
                    }
                }
                else {
                    deps.push({name: this.dataManager.getEntities().PERMISSION_GROUP, options: {isMandatory: false, isPersist: true}});
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    deps.push({name: this.dataManager.getEntities().LOB, options: {isMandatory: true, isPersist: true}});
                    if (!LE.sessionManager.getConfig().isLPA) {
                        deps.push({name: this.dataManager.getEntities().LOGGED_IN_USER, options: {isMandatory: true}});
                    }
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.moduleTabsController, "getView");
                        this.moduleTabsController.showUserList();
                    }, this)
                });
            },

            showAgentGroupsList: function() {
                LEUserManagement.logger.debug("showAgentGroupsList called" ,"UserManagementRouteController:showAgentGroupsList");

                if(!LE.sessionManager.hasAgentGroupsFeature()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true, isPersist: true, fetchOptions: {data: {getUsers:true}}}},
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true, isPersist: true}}
                    ];

                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: true, isPersist: true}});
                    if (!LEUserManagement.hasEntireAgentGroupTreePrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}, isPersist: true}});
                    }
                }
                else {
                    deps.push({name: this.dataManager.getEntities().PERMISSION_GROUP, options: {isMandatory: true, isPersist: true}});
                }

                this.dataManager.getDependencies({
                    dependencies: deps, //, this.dataManager.getEntities().PERMISSION_GROUP],
                    success: _.bind(function() {
                        this._showView(this.moduleTabsController, "getView");
                        this.moduleTabsController.showAgentGroupsList();
                    }, this)
                });
            },

            showAgentGroupMove: function(agentGroupId) {
                LEUserManagement.logger.debug("showAgentGroupMove called for id: " + agentGroupId ,"UserManagementRouteController:showAgentGroupMove");

                if(!LE.sessionManager.hasAgentGroupsFeature() || !agentGroupId) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true, fetchOptions: {data: {getUsers:true}}}},
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true}}
                ];

                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: true}});
                    if (!LEUserManagement.hasEntireAgentGroupTreePrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}}});
                    }
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        if(this.dataManager.getData(this.dataManager.getEntities().AGENT_GROUP).get(agentGroupId)) {
                            var view = this.agentGroupMoveController.getView({agentGroupId: agentGroupId});
                            this._showView(this.agentGroupMoveController, view);
                        } else {
                            LEUserManagement.router.navigate(this.navigation.defaultRoute);
                        }
                    }, this)
                });
            },

            showAgentGroupEdit: function(agentGroupId) {
                LEUserManagement.logger.debug("showAgentGroupEdit called for id: " + agentGroupId ,"UserManagementRouteController:showAgentGroupEdit");

                if(!LE.sessionManager.hasAgentGroupsFeature()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().SITE_SETTINGS_USER_LIST, options: {isMandatory: true}}
                ];

                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: true}});
                    if (!LEUserManagement.hasEntireAgentGroupTreePrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}}});
                    }
                }
                else {
                    deps.push({name: this.dataManager.getEntities().PERMISSION_GROUP, options: {isMandatory: true}});
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.agentGroupEditController, "getView");
                        this.agentGroupEditController.showAgentGroupEdit(agentGroupId);
                    }, this)
                });
            },

            showAgentGroupAdd: function(agentGroupId) {
                LEUserManagement.logger.debug("showAgentGroupAdd called for id: " + agentGroupId ,"UserManagementRouteController:showAgentGroupAdd");
                if(!LE.sessionManager.hasAgentGroupsFeature()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true}}
                ];

                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: true}});
                    if (!LEUserManagement.hasEntireAgentGroupTreePrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}}});
                    }
                }
                else {
                    deps.push({name: this.dataManager.getEntities().PERMISSION_GROUP, options: {isMandatory: true}});
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.agentGroupEditController, "getView");
                        this.agentGroupEditController.showAgentGroupAdd(agentGroupId);
                    }, this)
                });
            },

            showSkillList: function() {
                LEUserManagement.logger.debug("showSkillList called" ,"UserManagementRouteController:showSkillList");

                var deps = [{name: this.dataManager.getEntities().SKILL, options: {isMandatory: true, isPersist: true}}];

                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    deps.push({name: this.dataManager.getEntities().LOB, options: {isMandatory: true, isPersist: true}});
                    if (!LE.sessionManager.getConfig().isLPA) {
                        deps.push({name: this.dataManager.getEntities().LOGGED_IN_USER, options: {isMandatory: true}});
                    }
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.moduleTabsController, "getView");
                        this.moduleTabsController.showSkillList();
                    }, this)
                });
            },

            showSkillEdit: function(skillId) {
                LEUserManagement.logger.debug("showSkillEdit called for id: " + skillId ,"UserManagementRouteController:showSkillEdit");

                var deps = [];
                if (LE.sessionManager.hasAgentGroupsFeature() && LE.sessionManager.hasMultiChatCenterLoadBalancing()) {
                    deps.push({name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true}});
                }

                if (LE.sessionManager.hasConfigureDefaultSurveyForSkillChange()) {
                    deps.push({name: this.dataManager.getEntities().SURVEY, options: {isMandatory: true, fetchOptions: {data: {includeJson: false}}}});
                }
                if (LE.sessionManager.hasWrapUpTimeFeature()) {
                    deps.push({name: this.dataManager.getEntities().SITE_SETTINGS_WRAP_UP_TIME, options: {isMandatory: true}});
                }
                if (LE.sessionManager.hasSLAPerSkillFeature()) {
                    deps.push({name: this.dataManager.getEntities().SITE_SETTINGS_SLA, options: {isMandatory: true}});
                }
                if (LE.sessionManager.hasMessagingTransferToAgentFeature()) {
                    deps.push({ name: this.dataManager.getEntities().SITE_SETTINGS_TRANSFER_TO_AGENT, options: { isMandatory: true } });
                }
                if (LE.sessionManager.hasAutoClosePerSkillFeature()) {
                    deps.push({ name: this.dataManager.getEntities().SITE_SETTINGS_AUTO_CLOSE, options: { isMandatory: true } });
                }
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    deps.push({name: this.dataManager.getEntities().LOB, options: {isMandatory: true}});
                    if (!LE.sessionManager.getConfig().isLPA) {
                        deps.push({name: this.dataManager.getEntities().LOGGED_IN_USER, options: {isMandatory: true}});
                    }
                }
                deps.push({name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}});

                if (LEConfig.scheduledWorkingHours && LE.sessionManager.hasAsyncMessagingFeature()) {
                    deps.push({name: this.dataManager.getEntities().SCHEDULES});
                    deps.push({name: this.dataManager.getEntities().SPECIAL_OCCASIONS});
                    deps.push({name: this.dataManager.getEntities().SITE_SETTINGS_MANUAL_SHIFT_STATUS});
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.skillEditController, "getView");
                        this.skillEditController.showSkillEdit(skillId);
                    }, this)
                });
            },

            showAddSkill: function() {
                this.showSkillEdit(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showUserEdit: function(userId, action) {
                LEUserManagement.logger.debug("showUserEdit called for id: " + userId ,"UserManagementRouteController:showUserEdit");
                var hasBlockAddingUsersFeature = LE.sessionManager.hasBlockAddingUsersFeature();
                var isNewUser = (userId === LE.CONST.ROUTING.NEW_ITEM_ID || action === LE.CONST.ROUTING.DUPLICATE_ITEM);

                var deps = [
                    {name: this.dataManager.getEntities().USER, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().AGENT_GROUP, options: {isMandatory: true}}
                ];

                if (LE.sessionManager.hasProfilesFeature()) {
                    deps.push({name: this.dataManager.getEntities().PROFILES, options: {isMandatory: true}});
                    if (!LEUserManagement.hasAllUsersViewPrivilege()) {
                        deps.push({name: this.dataManager.getEntities().AGENT_MANAGER_MODEL, options: {isMandatory: true, fetchOptions: {data: {config:true}}}});
                    }
                }
                else {
                    deps.push({name: this.dataManager.getEntities().PERMISSION_GROUP, options: {isMandatory: true}});
                }
                if (LE.sessionManager.hasUserTypeBotFeature() && LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_API_KEYS_MANAGEMENT)) {
                    deps.push({name: this.dataManager.getEntities().API_KEYS, options: {isMandatory: false}});
                }
                if (hasBlockAddingUsersFeature && isNewUser) {
                    deps.push({name: this.dataManager.getEntities().NUM_OF_SEATS, options: {isMandatory: true}});
                }

                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    deps.push({name: this.dataManager.getEntities().LOB, options: {isMandatory: true}});
                    if (!LE.sessionManager.getConfig().isLPA) {
                        deps.push({name: this.dataManager.getEntities().LOGGED_IN_USER, options: {isMandatory: true}});
                    }
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        var actionMethod = (action === LE.CONST.ROUTING.DUPLICATE_ITEM) ? "showUserDuplicate" : "showUserEdit";

                        var numOfSeats = this.dataManager.getData(this.dataManager.getEntities().NUM_OF_SEATS).getSeats(); // can be undefined if not fetched - equivalent to Infinity
                        var tooManyUsers = (numOfSeats && numOfSeats <= this.dataManager.getData(this.dataManager.getEntities().USER).size());
                        var blockAddingUser = hasBlockAddingUsersFeature && isNewUser && tooManyUsers;

                        if (blockAddingUser) {
                            LEUserManagement.router.navigate("users");
                            LE.triggerTrialTrayItem();
                        }
                        else {
                            this._showView(this.userEditController, "getView");
                            this.userEditController[actionMethod](userId);
                        }
                    }, this)
                });
            },

            showLobList: function() {
                LEUserManagement.logger.debug("showLobList called" ,"UserManagementRouteController:showLobList");

                if(!LE.siteSettings.lobSettings.hasLobSettingEnabled()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [{name: this.dataManager.getEntities().LOB_RELATIONS, options: {isMandatory: true, isPersist: true}}];

                if (!LE.sessionManager.getConfig().isLPA) {
                    deps.push({name: this.dataManager.getEntities().LOGGED_IN_USER, options: {isMandatory: true}});
                }

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.moduleTabsController, "getView");
                        this.moduleTabsController.showLobList();
                    }, this)
                });
            },

            showLobEdit: function(lobId) {
                LEUserManagement.logger.debug("showLobEdit called for id: " + lobId ,"UserManagementRouteController:showLobEdit");

                this._showView(this.lobEditController, "getView");
                this.lobEditController.showLobEdit(lobId);
            },

            showAddLob: function() {
                this.showLobEdit(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showAddUser: function() {
                this.showUserEdit(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            showDuplicateUser: function(userId) {
                this.showUserEdit(userId, LE.CONST.ROUTING.DUPLICATE_ITEM);
            },

            showProfileList: function() {
                LEUserManagement.logger.debug("showProfileList called" ,"UserManagementRouteController:showProfileList");
                if(!LE.sessionManager.hasProfilesFeature()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().PROFILES_FULL_DATA, options: {isMandatory: true, isPersist: true}},
                    {name: this.dataManager.getEntities().DEFAULT_PROFILES, options: {isMandatory: true}}
                ];

                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(function() {
                        this._showView(this.moduleTabsController, "getView");
                        this.moduleTabsController.showProfileList();
                    }, this)
                });
            },

            showProfileEdit: function(profileId) {
                LEUserManagement.logger.debug("showProfileEdit called for id: " + profileId ,"UserManagementRouteController:showProfileEdit");
                if(!LE.sessionManager.hasProfilesFeature()) {
                    LEUserManagement.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                this.dataManager.getDependencies({
                    dependencies: [{name: this.dataManager.getEntities().DEFAULT_PROFILES, options: {isMandatory: true}}],
                    success: _.bind(function() {
                        this._showView(this.profileEditController, "getView");
                        this.profileEditController.showProfileEdit(profileId);
                    }, this)
                });
            },

            showAddProfile: function() {
                this.showProfileEdit(LE.CONST.ROUTING.NEW_ITEM_ID);
            },

            _showView: function(controller, view) {
                if (this.currentController && _.isFunction(this.currentController.onNavigateOut)) {
                    this.currentController.onNavigateOut();
                }

                if (_.isString(view)) {
                    view = controller[view]();
                }
                LEUserManagement.getMainRegion().add(view);

                this.currentController = controller;
            }
        });
    });
    return UserManagementRouteController;
});

